var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "box-card",
          attrs: { shadow: "never", bordered: false },
        },
        [
          _c("div", { staticClass: "tips" }, [
            _vm._v(
              " 改动即时生效（后端写库并刷新进程内缓存），不需要重启联盟服务。 红线项（自购返佣、等级差返佣）在页面上只读，不提供修改入口。 "
            ),
          ]),
          _c(
            "el-form",
            {
              attrs: { inline: "", size: "small" },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", loading: _vm.loading },
                      on: { click: _vm.loadConfig },
                    },
                    [_vm._v("刷新")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            { attrs: { data: _vm.list, size: "small", border: "" } },
            [
              _c("el-table-column", {
                attrs: { label: "序号", width: "60", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(_vm._s(_vm.$pageIndex(scope)))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "key", label: "配置项", "min-width": "240" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("div", [_vm._v(_vm._s(row.name))]),
                        _c("div", { staticClass: "key" }, [
                          _vm._v(_vm._s(row.key)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "当前值", "min-width": "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("span", [_vm._v(_vm._s(row.value))]),
                        row.unit
                          ? _c("span", { staticClass: "unit" }, [
                              _vm._v(_vm._s(row.unit)),
                            ])
                          : _vm._e(),
                        row.type === "RATIO"
                          ? _c("span", { staticClass: "unit" }, [
                              _vm._v(
                                "（" +
                                  _vm._s((row.value / 100).toFixed(2)) +
                                  "%）"
                              ),
                            ])
                          : _vm._e(),
                        row.type === "DECIMAL_FEN"
                          ? _c("span", { staticClass: "unit" }, [
                              _vm._v(
                                "（" +
                                  _vm._s((row.value / 100).toFixed(2)) +
                                  " 元）"
                              ),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "remark",
                  label: "说明",
                  "min-width": "320",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "100", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        !row.locked
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.openDialog(row)
                                  },
                                },
                              },
                              [_vm._v("修改")]
                            )
                          : _c(
                              "el-tag",
                              { attrs: { size: "mini", type: "danger" } },
                              [_vm._v("红线锁定")]
                            ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "修改配置",
            visible: _vm.dialogVisible,
            width: "560px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "90px",
                size: "small",
              },
            },
            [
              _c("el-form-item", { attrs: { label: "配置项" } }, [
                _c("div", [_vm._v(_vm._s(_vm.current.name))]),
                _c("div", { staticClass: "key" }, [
                  _vm._v(_vm._s(_vm.current.key)),
                ]),
              ]),
              _c("el-form-item", { attrs: { label: "说明" } }, [
                _c("div", { staticClass: "remark" }, [
                  _vm._v(_vm._s(_vm.current.remark)),
                ]),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "新值", prop: "value" } },
                [
                  _c("el-input", {
                    staticClass: "selWidth",
                    model: {
                      value: _vm.form.value,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "value",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.value",
                    },
                  }),
                  _vm.current.type === "RATIO"
                    ? _c("div", { staticClass: "hint" }, [
                        _vm._v(" 万分比整数，例如 1500 表示 15% "),
                        /^\d+$/.test(_vm.form.value)
                          ? _c("span", { staticClass: "ratio-preview" }, [
                              _vm._v(
                                " 当前填的是 " +
                                  _vm._s((_vm.form.value / 100).toFixed(2)) +
                                  "% "
                              ),
                            ])
                          : _vm._e(),
                      ])
                    : _vm.current.type === "INT"
                    ? _c("div", { staticClass: "hint" }, [_vm._v("整数")])
                    : _vm.current.type === "DECIMAL"
                    ? _c("div", { staticClass: "hint" }, [
                        _vm._v("金额，单位为元，最多两位小数"),
                      ])
                    : _vm.current.type === "DECIMAL_FEN"
                    ? _c("div", { staticClass: "hint" }, [
                        _vm._v(" 以"),
                        _c("b", [_vm._v("分")]),
                        _vm._v(
                          "为单位的整数，例如 100000 表示 1000 元；0 表示不限 "
                        ),
                        /^\d+$/.test(_vm.form.value)
                          ? _c("span", { staticClass: "ratio-preview" }, [
                              _vm._v(
                                " 当前填的是 " +
                                  _vm._s((_vm.form.value / 100).toFixed(2)) +
                                  " 元 "
                              ),
                            ])
                          : _vm._e(),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "primary",
                    loading: _vm.saving,
                  },
                  on: { click: _vm.submit },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }